import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';
import { isFunction } from 'lodash';

import Api from 'lib/api';

const api = Api.getInstance();

const ns = 'app/users/';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';

export const ADD_START = ns + 'ADD_START';
export const ADD_SUCCESS = ns + 'ADD_SUCCESS';
export const ADD_FAILURE = ns + 'ADD_FAILURE';

export const EDIT_START = ns + 'EDIT_START';
export const EDIT_SUCCESS = ns + 'EDIT_SUCCESS';
export const EDIT_FAILURE = ns + 'EDIT_FAILURE';

export const SAVE_START = ns + 'SAVE_START';
export const SAVE_SUCCESS = ns + 'SAVE_SUCCESS';
export const SAVE_FAILURE = ns + 'SAVE_FAILURE';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';

export const CORP_NP_LOADED = ns + 'CORP_NP_LOADED';

export function load(page = 1) {
  return async dispatch => {
    dispatch({
      type: LOAD_START
    });

    try {
      const response = await api.get('users', { params: { page: page } });
      const { data } = response;

      dispatch({
        type: LOAD_SUCCESS,
        payload: data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_FAILURE,
        payload: response
      });
    }
  };
}

export function add(values, history, resetForm) {
  return async dispatch => {
    dispatch({
      type: ADD_START
    });

    try {
      const response = await api.post('users', values);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: ADD_SUCCESS
        });

        toast.success('User created successfully!');

        if (resetForm && isFunction(resetForm)) {
          resetForm();
        }

        history.push('/users');
      } else {
        toast.error('Unable to create user.');

        dispatch({
          type: ADD_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: ADD_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};
        let _f;
        for (let field in response.errors) {
          _f = field;
          if (_f === 'username') {
            _f = 'userEmail';
          } else if (_f === 'password') {
            _f = 'userPwd';
          } else if (_f === 'confirm_password') {
            _f = 'confirmPwd';
          }
          throwErrors[_f] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function edit(userId) {
  return async dispatch => {
    dispatch({
      type: EDIT_START
    });

    try {
      const response = await api.get(`users/${userId}`);
      const { data } = response;

      dispatch({
        type: EDIT_SUCCESS,
        payload: data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: EDIT_FAILURE,
        payload: response
      });
    }
  };
}

export function save(userId, values, history, resetForm) {
  return async dispatch => {
    dispatch({
      type: SAVE_START
    });

    try {
      const response = await api.put(`users/${userId}`, values);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: SAVE_SUCCESS
        });

        toast.success('User saved successfully!');

        if (resetForm && isFunction(resetForm)) {
          resetForm();
        }

        history.push('/users');
      } else {
        toast.error('Unable to save user.');

        dispatch({
          type: SAVE_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};
        let _f;

        for (let field in response.errors) {
          _f = field;
          if (_f === 'username') {
            _f = 'userEmail';
          } else if (_f === 'password') {
            _f = 'userPwd';
          } else if (_f === 'confirm_password') {
            _f = 'confirmPwd';
          }
          throwErrors[_f] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function deleteUser(userId, reassignTo = null, callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START
    });

    try {
      let url = `users/delete/${userId}`;

      const response = await api.post(url, {
        reassign: reassignTo
      });

      const { data } = response;

      if (data.success) {
        dispatch({
          type: DELETE_SUCCESS
        });

        toast.success('User deleted successfully!');

        if (isFunction(callback)) {
          callback();
        }
      } else {
        toast.error('Unable to delete user.');

        dispatch({
          type: DELETE_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: DELETE_FAILURE,
        payload: response
      });
    }
  };
}

export function getCorporationsAndNonprofits() {
  return async dispatch => {
    const response = await api.get('users/corporations-and-nonprofits');

    if (response.data) {
      dispatch({
        type: CORP_NP_LOADED,
        payload: response.data
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/users/actions.js